module.exports = __webpack_public_path__ + "img/salsa-1.43e29bdf.jpg";